import { styled } from "@mui/material/styles";
import { FormControl } from "@mui/material";

const CustomSelectStyle = styled(FormControl)(() => ({
  "& label.Mui-focused": {
    color: "#5E70CC",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#00000014",
      borderRadius: "10px",
    },

    "&:hover fieldset": {
      borderColor: "#5E70CC",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#616FC6",
    },
  },
}));
export default CustomSelectStyle;
